import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { m } from 'motion-v'


export default /*@__PURE__*/_defineComponent({
  __name: 'MMotionLift',
  props: {
    delay: { default: 0.1 },
    as: { default: 'div' }
  },
  setup(__props: any) {



const motionEl = computed(() => m[__props.as])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(motionEl)), {
    initial: { scale: 0.96, y: 4 },
    animate: { scale: 1, y: 0 },
    transition: {
      type: 'spring',
      stiffness: 320,
      damping: 18,
      mass: 0.9,
      delay: __props.delay,
    }
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["transition"]))
}
}

})